/**
 * Copyright Mántum All Rights Reserved.
 */
import Playful from './playful';
import Simple from './simple';
import fetcher from '../fetcher';
import useSWR from 'swr';
import { useMemo } from 'react';

import type { DataSource, Theme } from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        entity?: string;
        refresh?: number;
        revalidate?: boolean;
    };
    dataSource?: DataSource;
    icon?: string;
    theme?: Theme;
    title?: string;
    type?: 'simple' | 'playful';
};

export default function Index(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {},
        type = 'simple'
    } = props

    // prettier-ignore
    const {
        refresh = undefined,
        revalidate = true
    } = advanced;

    const config = {
        refreshInterval: refresh,
        revalidateOnFocus: revalidate
    };

    const query = useMemo(() => {
        return props.dataSource
            ? {
                  url: props.dataSource.url,
                  args: {
                      body: props.dataSource.parameter,
                      headers: props.dataSource.headers,
                      method: props.dataSource.method,
                      namespace: props.dataSource.namespace
                  }
              }
            : null;
    }, [props.dataSource]);

    const { data, isLoading } = useSWR<number | string>(query, fetcher, config);

    return (
        <>
            {{
                simple: <Simple {...props} value={data} loading={isLoading} />,
                playful: <Playful {...props} value={data} loading={isLoading} />
            }[type] || undefined}
        </>
    );
}
